import React from 'react'
import { Box, Text } from "grommet"

import StatusCount from '../common/StatusCount'


const HealthStatusEnv = ({
    envName,
    envSelected,
    handleEnvSelect,
    up,
    down,
    partial,
    scheduled_down
}) => {

    return (
        <Box
            flex={false}
            margin='none' pad='none' gap='none' justify='center' align='center' alignSelf='center'
            background='light-3'
            name={"HealthStatusEnv-" + envName}
            direction="row">


            <Box cursor="pointer" plain margin="none" gap="none" onClick={() => handleEnvSelect(envName)} hoverIndicator={{ color: "light-1" }}>
                <Box direction="row" pad="xsmall" gap="none" border={{ side: "all", style: "dotted" }} >
                    <Box
                        background={envName === envSelected ? 'brand' : 'light-3'}
                        pad={envName === envSelected ? { horizontal: "xxsmall" } : "none"}
                        gap="none"
                        margin="none"
                    >
                        <Text margin='none'
                            weight="bold"
                            color={envName === envSelected ? 'white' : 'brand'}
                            size="xsmall">
                            {envName}
                        </Text>
                    </Box>
                    <Box direction="row" pad="none" gap="none">
                        {up > 0 &&
                            <StatusCount
                                label={up}
                                status='up'
                            />
                        }

                        {partial > 0 &&
                            <StatusCount
                                label={partial}
                                status='partial'
                            />
                        }

                        {down > 0 &&
                            <StatusCount
                                label={down}
                                status='down'
                            />
                        }

                        {scheduled_down > 0 &&
                            <StatusCount
                                label={scheduled_down}
                                status='scheduled_down'
                            />
                        }

                    </Box>
                </Box>

            </Box>

        </Box >
    )
}

export default HealthStatusEnv
